// Environment variables are loaded by Vite automatically
// Variables prefixed with VITE_OCULUS_ are exposed to the client
// 
// IMPORTANT: For Cloudflare Pages, environment variables must be set in:
// - Settings → Environment Variables → Production/Preview
// - The build will use these values at build time
// - After setting variables, you need to trigger a new build

// Debug: Always log environment variables in production to help troubleshoot
// This will show in the browser console so you can verify what values are being used
console.log('[Config] Environment variables:', {
  VITE_OCULUS_SERVER_URL: import.meta.env.VITE_OCULUS_SERVER_URL || '(not set - using fallback)',
  VITE_OCULUS_API_URL: import.meta.env.VITE_OCULUS_API_URL || '(not set - will auto-derive)',
  VITE_OCULUS_WS_URL: import.meta.env.VITE_OCULUS_WS_URL || '(not set - will auto-derive)',
  MODE: import.meta.env.MODE,
  PROD: import.meta.env.PROD,
  DEV: import.meta.env.DEV,
});

export const config = {
  serverUrl: import.meta.env.VITE_OCULUS_SERVER_URL || 'http://localhost:8787',
  apiUrl: import.meta.env.VITE_OCULUS_API_URL || (() => {
    // Auto-derive API URL from server URL, ensuring /api path
    let baseUrl = import.meta.env.VITE_OCULUS_SERVER_URL || 'http://localhost:8787';
    // Remove /api if present (we'll add it back)
    baseUrl = baseUrl.replace(/\/api\/?$/, '');
    // Always append /api for API endpoints
    return `${baseUrl}/api`;
  })(),
  wsUrl: import.meta.env.VITE_OCULUS_WS_URL || (() => {
    // Auto-derive WebSocket URL from server URL
    // WebSocket should connect to root, not /api path
    let url = import.meta.env.VITE_OCULUS_SERVER_URL || 'http://localhost:8787';
    // Remove /api if present (WebSocket is handled at root level)
    url = url.replace(/\/api\/?$/, '');
    // Remove trailing slash
    url = url.replace(/\/$/, '');
    // Convert http to ws or https to wss
    return url.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:');
  })(),
  env: import.meta.env.MODE || 'development',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

// Log final config values - always log so you can verify in production
console.log('[Config] Final configuration:', {
  serverUrl: config.serverUrl,
  apiUrl: config.apiUrl,
  wsUrl: config.wsUrl,
  env: config.env,
});

// Expose config globally for debugging (accessible via window.__OCULUS_CONFIG__)
if (typeof window !== 'undefined') {
  (window as any).__OCULUS_CONFIG__ = config;
  console.log('[Config] Config exposed globally as window.__OCULUS_CONFIG__');
}
